import { type ApolloError, useQuery } from '@apollo/client';
import {
  DEAL_PROMPT_US_REGION_CODE,
  type UseDealPromptCountryOptions,
} from '@openx/components-deal-prompt/lib/utils/types';
import type { Option } from '@openx/types/options';
import { useMemo } from 'react';
import {
  GetAvailableCountriesDocument,
  type GetAvailableCountriesQuery,
} from '../../../graphql/fragment/audiences/GetAvailableCountries.generated';

export const useDealPromptCountryOptions: UseDealPromptCountryOptions = (region, skip) => {
  const shouldFetchCountries = !skip && Boolean(region) && region !== DEAL_PROMPT_US_REGION_CODE;

  const { data, loading, error } = useQuery<GetAvailableCountriesQuery>(GetAvailableCountriesDocument, {
    skip: !shouldFetchCountries,
    variables: {
      filter: { used: true, region },
    },
  });

  const countryOptions = useMemo<Option[]>(
    () =>
      (data?.optionsByPath ?? [])
        .filter((country): country is NonNullable<typeof country> => country !== null)
        .map(country => ({
          id: country.id,
          name: country.name,
        })),
    [data?.optionsByPath]
  );

  return {
    loading: shouldFetchCountries && loading,
    error: error as ApolloError | undefined,
    data: countryOptions,
  };
};
